import { CatmullRomCurve3, Group, Mesh, MeshPhysicalMaterial, SphereGeometry, TubeGeometry, Vector3, type Material } from 'three';
export interface HybridNosePads {
  /** Absolute mm in unwrapped front coordinates; pair mirrored around X=0. */
  center: [number,number,number];
  size: [number,number,number];
  arm: Array<[number,number,number]>;
  armRadiusMm: number;
  rotationZRad: number;
  rotationYRad?: number;
  rotationXRad?: number;
  opacity?: number;
}
/** Clear pads remain separate from the photographed front aperture. Dimensions are estimates unless measured. */
export function createHybridNosePads(spec: HybridNosePads, metal: Material, wrapRadiusMm=250):Group {
 if(spec.size.some(v=>!Number.isFinite(v)||v<=0)||!(spec.armRadiusMm>0)||spec.arm.length<2)throw new Error('Invalid hybrid nose pads');
 const pair=new Group();pair.name='hybrid_nose_pads';
 const clear=new MeshPhysicalMaterial({color:'#d9d7cf',roughness:.16,metalness:0,transparent:true,opacity:spec.opacity ?? .28,depthWrite:false,transmission:0,clearcoat:1,clearcoatRoughness:.15});
 clear.userData.fixedMetal=true;
 const bent=([x,y,z]:[number,number,number],side:number)=>new Vector3(side*x,y,z-x*x/(2*wrapRadiusMm));
 for(const side of [-1,1]) {
  const pad=new Mesh(new SphereGeometry(1,20,12),clear);pad.name=side<0?'nose_pad_R':'nose_pad_L';
  pad.scale.set(...spec.size.map(v=>v/2) as [number,number,number]);
  pad.rotation.order='ZYX';pad.rotation.set(spec.rotationXRad ?? 0,-side*(spec.rotationYRad ?? 0),side*spec.rotationZRad);pad.position.copy(bent(spec.center,side));pad.renderOrder=1;pad.userData.fixedMetal=true;pair.add(pad);
  const curve=new CatmullRomCurve3(spec.arm.map(p=>bent(p,side)));
  const arm=new Mesh(new TubeGeometry(curve,12,spec.armRadiusMm,6,false),metal);arm.name=side<0?'nose_pad_arm_R':'nose_pad_arm_L';arm.userData.fixedMetal=true;pair.add(arm);
 }
 return pair;
}
